import { Pipe, PipeTransform } from '@angular/core';
import { StringService } from '../commons/string.service';

@Pipe({
  name: 'abreviarNome'
})
export class AbreviarNomePipe implements PipeTransform {
  constructor(private stringService: StringService) {}

  transform(fullName: string, locale: string = 'pt-BR'): string {
    return this.stringService.abbreviateName(fullName, { locale });
  }
}
